import { MatDialogConfig } from '@angular/material/dialog';
import { Scopes } from './scopes.model';

export enum TemplateTypes {
  PDF = 'pdf',
  RTF = 'rtf',
  FOLDER = 'docs',
}

export const routeMap: Record<TemplateTypes, string> = {
  [TemplateTypes.RTF]: 'text-tmp',
  [TemplateTypes.FOLDER]: 'folder-tmp',
  [TemplateTypes.PDF]: 'doc-tmp',
};

export const templateTypes = [TemplateTypes.PDF, TemplateTypes.RTF];

export interface DocumentTemplateType {
  name: string;
  value: TemplateTypes;
  icon: string;
}

export interface DocumentTemplateDialog {
  template: DocumentTemplate;
  isTemplateData: boolean;
}

export const documentTemplateDialogConfig: MatDialogConfig = {
  width: '700px',
  autoFocus: false,
};

export interface DocumentTemplate {
  _id: string;
  _cby: User;
  _cts: string;
  _uby?: User;
  _uts: string;
  _scopes: Scopes;
  name: string;
  tp: TemplateTypes;
  dataMeta: DataMeta;
  data?: ITemplateData[];
  history?: any[];
}

export interface DataMeta {
  count: number;
  templateData: TemplateDataMeta[];
}

export interface TemplateDataMeta {
  id: string;
  vts: string;
}

export interface DocumentTemplatesPlaceholders {
  tp: 'signature' | 'date' | 'field';
  page: number;
  x: number;
  y: number;
  w: number;
  h: number;
  id?: string;
}

export interface DocumentTemplatesControlRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface SignatureDocumentTemplatesPlaceholder
  extends DocumentTemplatesPlaceholders {
  tp: 'signature';
}

export function isSignaturePlaceholder(
  placeholder: DocumentTemplatesPlaceholders
): placeholder is SignatureDocumentTemplatesPlaceholder {
  return placeholder.tp === 'signature';
}

export interface DateDocumentTemplatesPlaceholder
  extends DocumentTemplatesPlaceholders {
  tp: 'date';
}

export function isDatePlaceholder(
  placeholder: DocumentTemplatesPlaceholders
): placeholder is DateDocumentTemplatesPlaceholder {
  return placeholder.tp === 'date';
}

export interface FieldDocumentTemplatesPlaceholder
  extends DocumentTemplatesPlaceholders {
  tp: 'field';
  attr: 'string';
}

export function isFieldPlaceholder(
  placeholder: DocumentTemplatesPlaceholders
): placeholder is FieldDocumentTemplatesPlaceholder {
  return (
    placeholder.tp === 'field' &&
    (placeholder as FieldDocumentTemplatesPlaceholder).attr === null
  );
}

export interface ITemplateData {
  _id: string;
  _cts: string;
  baseDocId: string;
  bdy?: any; // Text template content
  tpl: {
    recipients: Recipient[];
  };
  _cby: User;
  _sVts: number;
  _uby: User;
  _uts: string;
  _vsg: string;
  _vts: number;
}

interface Recipient {
  email: string;
  placeholders: DocumentTemplatesPlaceholders[];
}

export interface User {
  usrId: string;
  name: string;
  email: string;
}

export interface DraggingMode {
  mode: 'w' | 'e' | 'n' | 's' | 'center';
  startingRect: DocumentTemplatesControlRect;
  pickupPositionInElement: { x: number; y: number };
}

export type TemplateDataHistory = Omit<ITemplateData, 'tpl'>[];
